import React from 'react'
import { Link } from "react-router-dom";
const AboutCTA = () => {
  return (
    <section className="cta py-5 main-bg text-center text-white">
    <div className="container">
      <h2 className="fw-bold mb-3">Ready to Start Shopping?</h2>
      <p className="mb-4">Explore our wide range of products and find what you love!</p>
      <Link to="/products" className="btn btn-outline-warning btn-lg px-4">
  Shop Now
</Link>
        </div>
  </section>
  )
}

export default AboutCTA